export const TipoResultadoBusca = {

  TODOS: { id: 1, nome: 'Todos', referencia: '' },
  VIDEOS: { id: 2, nome: 'Vídeos', referencia: 'video' },
  CURSOS: { id: 3, nome: 'Cursos', referencia: 'curso' },
  QUESTOES: { id: 4, nome: 'Questões', referencia: 'questao' },
  DISCIPLINAS: { id: 5, nome: 'Disciplinas', referencia: 'disciplina' },
  SISTEMAS: { id: 6, nome: 'Sistemas', referencia: 'sistema' },
  CATEGORIAS: { id: 7, nome: 'Categorias', referencia: 'categoria' },
  RESUMOS: { id: 8, nome: 'Resumos', referencia: 'resumo' },
  IMAGENS: { id: 9, nome: 'Imagens', referencia: 'imagem' }

}

export const TipoResultadoBuscaUtil = {

  obterPorReferencia: referencia => {
    const key = Object.keys(TipoResultadoBusca).find(item => TipoResultadoBusca[item].referencia === referencia)
    if (key) {
      return TipoResultadoBusca[key]
    }
    return {}
  }

}

export default TipoResultadoBusca
